export const CREATE_DOCUMENTS = "createDocuments";
export const GET_DOCUMENT_AUTHORS = "getDocumentAuthors";
export const DELETE_DOCUMENTS = "deleteDocuments";
export const UPDATE_DOCUMENT = "updateDocument";
export const LIST_DOCUMENTS = "listDocuments";
export const QUERY_DOCUMENTS = "queryDocuments";
export const GET_DOCUMENT_ANSWERS = "getDocumentAnswers";
export const GET_DOCUMENT_ANSWER_META = "getDocumentAnswerMeta";
export const GET_DOCUMENT_TRANSLATION_HIGHLIGHT = "getTranslationHighlight";
export const GET_CITATION_HIGHLIGHT = "getCitationHighlight";
export const SCAN_DOCUMENTS = "scanDocuments";
export const APPROVE_OCR_DOCUMENTS = "approveOcrDocuments";
export const INDEX_DOCUMENTS = "indexDocuments";
export const GET_DOCUMENT_BY_ID = "getDocumentById";
export const UPLOAD_SEARCH_FEEDBACK = "uploadSearchFeedback";
export const GET_DOCUMENT_CHUNKS_BY_IDS = "getDocumentChunksByIds";
